import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { TranslationContext } from '../../contexts/TranslationContext';
import { IUserSolution } from "../../services/WebApiClient";


export function SaveSuccessModal(props: {
    userSolution: IUserSolution;
    onClose: () => void;
}) {

    const tc = useContext(TranslationContext);

    return (
        <Modal onHide={props.onClose}
            show
            animation={false}
            centered
            size="sm"
            className="save-success-modal">

            <Modal.Header
                closeButton
                closeLabel={tc.translator("modal close label", "Luk")}>
                {tc.translator("save success modal header", "Løsning gemt")}
            </Modal.Header>

            <Modal.Body>
                <div style={{ whiteSpace: "pre-line" }}>
                    {tc.translator(
                        "save success modal text",
                        "Din løsning er nu gemt, og kan hentes frem i din lokal butik.\n\nTegningen hentes frem ved at give butikken dit telefonnummer.\n\nDu kan nu gennemgå dit forslag med sælgeren, og evt. rette indretning og døre til, så det stemmer helt overens med dine ønsker og behov.\n\nDu kan også hente tilbuddet som .pdf."
                    )}
                </div>
                <a className="btn btn-primary btn-block"
                    href={props.userSolution.pdfPath}
                    download={props.userSolution.name + ".pdf"}
                >
                    {tc.translator(
                        "save success modal download button",
                        "Hent løsning som .pdf"
                    )}
                </a>
            </Modal.Body>
        </Modal>
    );
}
